<template>
  <div class="micro">
    <div id="content">
      <Row :gutter="30">
        <Col span="14">
          <div class="headline font24">
            <span>爱学堂微课</span>
            <a class="more font14" :href="'http://'+siteResUrl + '/#/MicroClass'">更多<img style="height: 12px;margin-left: 2px;position: relative;top: 1px;" src="/static/images/more.png" alt=""></a>
          </div>
          <div class="microbox">
            <Row :gutter="21">
              <Col span="8" v-for="item in microList" :key="item.id">
                <div class="microcon pointer" @click="videoPlayer(item.videoId,item.name,1,item.id)" :title="item.name">
                  <div class="imgbox"><img :src="imgurl + item.imgurl" alt=""></div>
                  <div class="text">{{item.name}}</div>
                </div>
              </Col>
            </Row>

          </div>
        </Col>

        <Col span="10">
          <div class="headline font24">
            <span>资源中心</span>
            <a class="more font14" :href="'http://'+siteResUrl + '/#/SynchronizeResources'">更多<img style="height: 12px;margin-left: 2px;position: relative;top: 1px;" src="/static/images/more.png" alt=""></a>
          </div>
          <div class="resbox">
            <div class="restop">
              <img src="/static/images/restop.png" alt="">
            </div>
            <div class="resbtm">
              <div class="tab">
                <Row>
                  <Col span="8"><div :class="tabactive === 1? 'tabitem active':'tabitem'" @click="choseTab(1)">课件</div></Col>
                  <Col span="8"><div :class="tabactive === 2? 'tabitem active':'tabitem'" @click="choseTab(2)">学案</div></Col>
                  <Col span="8"><div :class="tabactive === 3? 'tabitem active':'tabitem'" @click="choseTab(3)">试卷</div></Col>
                </Row>
              </div>
              <div class="tabbox" v-show="tabactive === 1">
                <div class="tabcon pointer" v-for="(ppt,index) in pptList" :key="index" :title="ppt.name">
                  <div class="fl tabcontext font16"  @click="view(ppt)">
                    <img src="/static/images/ppt_icon.png" alt="">
                    {{ppt.name}}</div>
                  <div class="fr tabcontime font14">{{ppt.createTime}}</div>
                </div>
              </div>
              <div class="tabbox" v-show="tabactive === 2">
                <div class="tabcon pointer" v-for="(casetext,index) in caseList" :key="index" :title="casetext.name">
                  <div class="fl tabcontext font16"  @click="view(casetext)">
                    <img src="/static/images/docImg.png" alt="">
                    {{casetext.name}}
                    </div>
                  <div class="fr tabcontime font14">{{casetext.createTime}}</div>
                </div>
              </div>
              <div class="tabbox" v-show="tabactive === 3">
                <div class="tabcon pointer" v-for="(testPaper,index) in testPaperList" :key="index" :title="testPaper.handoutTitle">
                  <div class="fl tabcontext font16"  @click="view(testPaper)">
                    <img src="/static/images/docImg.png" alt="">
                    {{testPaper.handoutTitle}}
                    </div>
                  <div class="fr tabcontime font14">{{testPaper.handoutCreateTime}}</div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
  </div>
</template>

<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  import message from '../Message/Message'
  import cookie from '../../assets/getCookie.js'
  export default {
    name: 'micro',
    data () {
      return {
        tabactive:1,
        msg:'tab1',
        microList:null,                                         //微课列表  array
        pptList:null,                                            //课件    列表
        caseList:null,                                          //学案
        testPaperList:null,                                       //试卷
        imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
        isShowMessage:false,
        msg:null,
        shareSchoolId:null,
        teacherId:null,
        userType:null,
        siteResUrl:null
      }
    },
    created() {

    },
    mounted() {
      // this.$axios.defaults.baseURL='http://192.168.0.52:28080';
      // var r1 = this.$axios.get('/axt-future/knowledgeVideo/pageKnowledgeVideosByCondition');
      // var r2 = this.$axios.get('/axt-future/knowledgePPT/pageKnowledgePPTsByCondition');

      // this.$axios.all([r1, r2])
      // .then(this.$axios.spread((res1, res2) => {
      //     this.res1=res1.data;
      //     this.res2=res2.data;
      // }))
      // .catch(err=>{
      //     console.log(err);
      // })
      // const that = this;
      this.websiteId = localStorage.getItem('websiteId');
      this.siteResUrl = localStorage.getItem('siteResUrl')
       const cookie_token = cookie.getCookie('AXY_'+ this.websiteId +'_access_token')
       if(cookie_token){
           if(cookie_token != 'null'){
               //console.log('以登录',cookie_token)
               this.shareSchoolId = localStorage.getItem('schoolId');
               this.teacherId = localStorage.getItem('userId');
               this.userType = localStorage.getItem('userType')

           }
       }else{
           //console.log('未登录',cookie_token)
           this.shareSchoolId = null;
           this.teacherId = null;
       }
      this.getIndexMicroData();
      this.getIndexPptData()
      this.getIndexCaseData()
      this.getTestPaperData()
    },
    methods:{
      choseTab(name){
        if(name == 1){

        }else if(name == 2){

        }else {

        }
        this.tabactive = name;
      },
      //获取微课列表
      getIndexMicroData() {
        const that = this;
        const url = '/axt-future/knowledgeVideo/pageKnowledgeVideosByCondition';
        const params = {
          pageSize: 10,
          pageNo: 1,
          gradeIds: null,
          subjectId: null,
          versionId: null,
          distinct_videoId:1
        }
       // console.log(params,"params")
        api.getListAPI(url, params).then(res => {
          if (res.data.message == 'success') {
            let list = res.data.data.rows;
            that.microList = that.getArrayItems(list,6);
          }
        })
      },
      getIndexPptData(){
        const that = this;
         const url = '/axt-future/knowledgePPT/pageKnowledgePPTsByCondition';
         const params = {
           pageSize: 20,
           pageNo: 1
           }
         api.getListAPI(url, params).then(res => {
           if (res.data.message == 'success') {
             let list = res.data.data.rows;
             that.pptList = that.getArrayItems(list,10);
             // console.log(that.pptList,"ppt")
           }
         })
      },
      getIndexCaseData(){
        const that = this;
         const result = [];
         const url = '/axt-future/knowledgeLearningPlan/pageKnowledgeLearningPlansByCondition';
         const params = {
           pageSize: 20,
           pageNo: 1
           }
        // console.log(params,"params")
         api.getListAPI(url, params).then(res => {
           if (res.data.message == 'success') {
             let list = res.data.data.rows;
             that.caseList = that.getArrayItems(list,10);
             // console.log(that.caseList,"case")
           }
         })
      },
      getTestPaperData(){
        const that = this;
        const url = '/axt-examination/daily_practice/pageHandoutList';
        var params = {
            pageSize:20,
            pageNo:1,
            orderBys:[
                {
                    field:'handout_create_time',
                    direction:'desc'
                }
            ]
        };
        api.postFormAPI(url,params).then(res => {
            //console.log(res)
            if(res.data.message == 'success'){
                if(res.data.data.total == 0 || res.data.data == null){
                }else{
                   let list = res.data.data.rows;
                   that.testPaperList = that.getArrayItems(list,10);
                   // console.log(that.testPaperList,"test")
                }

            }

        })
      },
      view(obj){
          if(this.teacherId == null || this.teacherId == undefined){
              this.isShowMessage = true;
              this.msg = ('您尚未登录');
              return false
          }
          this.$emit("isplay",true)
          let url = '';
          if(this.tabactive == 3){
            url = obj.handoutOriginalDocPath || obj.handoutQuestionFilePath || obj.handoutAnalysisFilePath
          }else {
            url = obj.downloadUrl
          }
          if (/\.ppt/gi.test(url) || /\.pptx/gi.test(url)
              || /\.doc/gi.test(url) || /\.docx/gi.test(url)
              || /\.xls/gi.test(url) || /\.xlsx/gi.test(url)
              || /\.jpg/gi.test(url) || /\.png/gi.test(url)
              || /\.pdf/gi.test(url)) {

                  this.getMaterialUrl(url);
          }else {
              if(this.tabactive == 3){
                  var src = 'http://qcbantk.aixuetang.com/doc'+ url;
              }else{
                  var src = 'http://qcban.aixuetang.com/res'+ url;
              }

              bus.$emit('materialSrc',src)
          }
      },
      getMaterialUrl(src){
          const that = this;
          if(this.tabactive == 3){
              var url =  '/axt-resources/preview/selectTkDocumentPreviewUrl';
          }else{
              var url =  '/axt-resources/preview/selectDocumentPreviewUrl';
          }
          const params = {
              'downloadUrl':src
          }
          api.getListAPI(url,params).then(res => {
              // console.log(res,"jjjjjjjj")
              bus.$emit('materialSrc',res.data.data)
          })
      },
      getArrayItems(arr, num){
        var temp_array = new Array();
        for (var index in arr) {
            temp_array.push(arr[index]);
        }
        var return_array = new Array();
        for (var i = 0; i<num; i++) {
            if (temp_array.length>0) {
                var arrIndex = Math.floor(Math.random()*temp_array.length);
                return_array[i] = temp_array[arrIndex];
                temp_array.splice(arrIndex, 1);
            } else {
                break;
            }
        }
        return return_array;
      },
      //点击播放
      videoPlayer(videoId,name,sourse,id){
        if(this.teacherId == null || this.teacherId == undefined){
            this.isShowMessage = true;
            this.msg = ('您尚未登录');
            return
        }
        this.$emit('showPlayer',true)
        const vidoeData = {
          videoId:videoId,
          name:name,
          sourse:sourse,
          id:id
        }
        this.$nextTick(() => {
            bus.$emit('videoId',vidoeData)
        })

      },
      isShowMsg(msg){
          this.isShowMessage = false;
      }
    },
    components:{message}
  }
</script>

<style scoped="scoped">
  .micro {
    padding: 60px 0 0px;
  }
  #content {
    width: 1200px;
    margin-bottom: 40px;
  }
  .headline {
    text-align: left;
    line-height: 1.8;
    border-bottom: 2px solid #3583FF;
    position: relative;
    font-weight: 500;
  }
  .headline .more {
    color: #3583FF;
    float: right;
    position: relative;
    top: 10px;
    
    cursor: pointer;
  }
  .microbox, .resbox {
    margin-top: 35px;
  }
  .microcon {
    margin-bottom: 30px;
    border: 1px solid #E7E7E7;
    border-radius: 14px;
    overflow: hidden;
    transition: all .5s;
  }
  .microcon .imgbox img{
    width: 100%;
    height: 126px;
  }
  .microcon .text {
    padding: 10px 6%;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #34495E;
    text-align: left;
    font-size: 16px;
  }
  .microcon:hover {
    margin-top: -10px;
  }
  .restop img{
    width: 100%;
  }
  .resbtm {
    margin-top: 10px;
    border-radius: 14px;
    border: 1px solid #E7E7E7;
    overflow: hidden;
  }
  .resbtm .tab {
    background: #F4F4F4;
    height: 49px;
    line-height: 49px;
  }
  .resbtm .tab .tabitem {
    color: #34495E;
    font-size: 20px;
    cursor: pointer;
  }
  .resbtm .tabitem.active {
    color: #FFFFFF;
    background-color:#3583FF ;
  }
  .tabbox {
    height: 218px;
    padding: 0 20px;
    overflow: hidden;
    overflow-y: auto;
  }
  .tabbox::-webkit-scrollbar{
    width:10px;
    height:10px;
    /**/
  }
  .tabbox::-webkit-scrollbar-track{
    background: rgb(239, 239, 239);
    border-radius:2px;
  }
  .tabbox::-webkit-scrollbar-thumb{
    background: #bfbfbf;
    border-radius:10px;
  }
  .tabbox::-webkit-scrollbar-corner{
    background: #179a16;
  }
  .tabcon {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #E7E7E7;
  }
  .tabcon:last-of-type {
    border-bottom: none;
  }
  .tabcon .tabcontext {
    width: 66%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    color: #34495E;
    font-weight: 500;
  }
  .tabcon .tabcontext img {
    height: 38px;
    vertical-align: middle;
    margin-right: 10px;
  }
  .tabcon .tabcontime {
    color:#9A9A9A ;
  }
  .tabcon:hover .tabcontext {
    color: #3583FF;
  }
  @media screen and (min-width: 1920px) {
    #content {
      width: 87.5%;
    }
    .tabbox {
        height: 298px;
      }
    .tabcon {
      height: 80px;
      line-height: 80px;
    }
    .microcon .text {
      font-size: 20px;
    }
    .microcon .imgbox img {
      height: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexContent/microVideo.vue